/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubsystemResponseDto
 */
export interface SubsystemResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SubsystemResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SubsystemResponseDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof SubsystemResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SubsystemResponseDto
     */
    description?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SubsystemResponseDto
     */
    metadataSchema?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Date}
     * @memberof SubsystemResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof SubsystemResponseDto
     */
    updatedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof SubsystemResponseDto
     */
    assetTypesCount: number;
}

/**
 * Check if a given object implements the SubsystemResponseDto interface.
 */
export function instanceOfSubsystemResponseDto(value: object): value is SubsystemResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('assetTypesCount' in value) || value['assetTypesCount'] === undefined) return false;
    return true;
}

export function SubsystemResponseDtoFromJSON(json: any): SubsystemResponseDto {
    return SubsystemResponseDtoFromJSONTyped(json, false);
}

export function SubsystemResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubsystemResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'metadataSchema': json['metadataSchema'] == null ? undefined : json['metadataSchema'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'assetTypesCount': json['assetTypesCount'],
    };
}

export function SubsystemResponseDtoToJSON(json: any): SubsystemResponseDto {
    return SubsystemResponseDtoToJSONTyped(json, false);
}

export function SubsystemResponseDtoToJSONTyped(value?: SubsystemResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'name': value['name'],
        'description': value['description'],
        'metadataSchema': value['metadataSchema'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'assetTypesCount': value['assetTypesCount'],
    };
}

